<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown class="cursor-pointer" vs-trigger-click>
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
                                                        <span class="mr-2"
                                                        >{{
                                                                        currentPage * paginationPageSize -
                                                                                (paginationPageSize - 1)
                                                                }}
                                                                -
                                                                {{
                                                                        customers.length -
                                                                                currentPage * paginationPageSize >
                                                                        0
                                                                                ? currentPage * paginationPageSize
                                                                                : customers.length
                                                                }}
                                                                de {{ customers.length }}</span
                                                        >
              <feather-icon icon="ChevronDownIcon" svg-classes="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH, EXPORT AS CSV & CREATE USER -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-input
            @input="updateSearchQuery"
            class="mb-4 md:mb-0 mr-4"
            placeholder="Buscar..."
            v-model="searchQuery"
          />
          <vs-button @click="gridApi.exportDataAsCsv({
            fileName: 'usuarios_conjunto_' + conjuntos[0].nombre.toLowerCase() +'_'+ new Date().getUTCDay() +'_'+ new Date().getUTCMonth() +'_'+ new Date().getUTCFullYear(),
            })" class="mb-4 md:mb-0"
          >Exportar como CSV
          </vs-button
          >
          <vs-button @click="addUser()" class="mb-4 md:mb-0 md:ml-4"
          >Agregar nuevo usuario
          </vs-button
          >
        </div>
      </div>
      <AgGridVue
        :animate-rows="true"
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :floating-filter="true"
        :grid-options="gridOptions"
        :pagination="true"
        :pagination-page-size="paginationPageSize"
        :row-data="customers"
        :suppress-pagination-panel="true"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        col-resize-default="shift"
        row-selection="multiple"
      ></AgGridVue>
      <vs-pagination
        :max="maxPageNumbers"
        :total="totalPages"
        v-if="totalPages >= 1"
        v-model="currentPage"
      />
    </vx-card>
  </div>
</template>

<script>
    import {AgGridVue} from 'ag-grid-vue';

    import '@/assets/scss/agGridStyleOverride.scss';
    import {mapState} from 'vuex';


    export default {
        components: {
            AgGridVue,
        },
        data() {
            return {
                searchQuery: '',
                gridOptions: {},
                maxPageNumbers: 7,
                gridApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                },
                columnDefs: [
                    {
                        headerName: 'ID Usuario',
                        field: 'id',
                        width: 200,
                        filter: true,
                        cellRenderer: function (params) {
                            return params.value.substr(-12, 12);
                        },
                        checkboxSelection: true,
                        headerCheckboxSelectionFilteredOnly: true,
                        headerCheckboxSelection: true,
                    },
                    {
                        headerName: 'Bloque',
                        field: 'unidad.nombre_bloque',
                        filter: true,
                        width: 150,
                    },
                    {
                        headerName: 'Unidad',
                        field: 'unidad.nombre_unidad',
                        filter: true,
                        width: 150,
                    },
                    {
                        headerName: 'Nombre',
                        field: 'firstName',
                        filter: true,
                        width: 135,
                    },
                    {
                        headerName: 'Apellidos',
                        field: 'lastName',
                        filter: true,
                        width: 135,
                    },
                    {
                        headerName: 'Cedula Ciudadania',
                        field: 'cc',
                        filter: true,
                        width: 165,
                    },
                    {
                        headerName: 'Telefono',
                        field: 'phone',
                        filter: true,
                        width: 150,
                    },
                    {
                        headerName: 'Email',
                        field: 'email',
                        filter: true,
                        width: 250,
                        pinned: 'left',
                    },
                    {
                        headerName: 'Parqueadero Asignado',
                        field: 'parqueadero_asignado',
                        filter: 'agNumberColumnFilter',
                        width: 150,
                    },
                    {
                        headerName: '# de Mascotas',
                        field: 'pets',
                        filter: 'agNumberColumnFilter',
                        width: 150,
                        cellRenderer: function (params) {
                            return params.value.length;
                        },
                    },
                    {
                        headerName: '# de Vehiculos',
                        field: 'vehicles',
                        filter: 'agNumberColumnFilter',
                        width: 150,
                        cellRenderer: function (params) {
                            return params.value.length;
                        },
                    },
                ],
            };
        },
        watch: {
            '$store.state.windowWidth'(val) {
                if (val <= 576) {
                    this.maxPageNumbers = 4;
                    this.gridOptions.columnApi.setColumnPinned('email', null);
                } else this.gridOptions.columnApi.setColumnPinned('email', 'left');
            },
        },
        computed: {
            ...mapState(['customers', 'conjuntos']),
            paginationPageSize() {
                if (this.gridApi) return this.gridApi.paginationGetPageSize();
                else return 50;
            },
            totalPages() {
                if (this.gridApi) return this.gridApi.paginationGetTotalPages();
                else return 0;
            },
            currentPage: {
                get() {
                    if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                    else return 1;
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1);
                },
            },
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
        },
        methods: {
            getTotalPages() {
                console.log(this.gridApi.paginationGetTotalPages());
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val);
            },
            addUser() {
               this.$router.push({name: 'createUsers'})
            }
        },
    };
</script>
